import { Component, OnInit } from '@angular/core';
import { BackgroundComponent } from '../background/background.component';

@Component({
    selector: 'congratulations',
    templateUrl: './congratulations.component.html',
    imports: [BackgroundComponent]
})
export class CongratulationsComponent {}
